define('gumbo-js-client-lib/forms/liveData/PitchMetaDataForm',{
	startSpeed: null,
	endSpeed: null,
	nastyFactor: null,
	strikezoneBottom: null,
	strikezoneTop: null,
	coordinates: {
		aX: null,
		aY: null,
		aZ: null,
		pfxX: null,
		pfxZ: null,
		pX: null,
		pZ: null,
		vX0: null,
		vY0: null,
		vZ0: null,
		x: null,
		y: null,
		x0: null,
		y0: null,
		z0: null
	},
	breaks: {
		breakAngle: null,
		breakLength: null,
		breakX: null,
		breakY: null,
		breakZ: null
	}
});
